'use strict';

/*@ngInject*/
module.exports = function($scope) {
	// set carousel item number: detail count
	$scope.slideCount = { 
		0: {
			detailCount: 0
		}, 
		1: {
			detailCount: 4
		}, 
		2: {
			detailCount: 4
		}, 
		3: {
			detailCount: 4
		}, 
		4: {
			detailCount: 4
		} 
	};

	$scope.learnMore = function(index) {
		var slide = $scope.slideCount[index];
		if (slide) {
			slide.showMore = !slide.showMore;
		}
	};
};